import { HStack, Icon, IconButton } from '@chakra-ui/react';
import Body2 from '@components/typography/Body2';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { titleCase } from 'title-case';

const ClientName = ({ name, isExpanded }) => {
  return (
    <HStack gap={2}>
      <IconButton
        aria-label="status"
        colorScheme="primary"
        variant="outline"
        size="sm"
        icon={<Icon as={FontAwesomeIcon} icon={isExpanded ? faChevronUp : faChevronDown} />}
      />
      <Body2>{titleCase(name.toLowerCase())}</Body2>
    </HStack>
  );
};

export default ClientName;
